import { useLang } from "../context/LanguageContext";
import Logo from "./Logo";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0A1128] text-[#F4F1EB] mt-24" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <Logo size={110} variant="square" className="rounded-sm shadow-[0_0_0_1px_rgba(197,160,89,0.15)]" />
          <p className="mt-6 text-sm text-[#F4F1EB]/70 font-light leading-relaxed max-w-xs">
            {t.footer.tagline}
          </p>
        </div>
        <div className="text-sm">
          <div className="overline mb-4">{t.nav.contact}</div>
          <p className="text-[#F4F1EB]/80">stayzenpremium@gmail.com</p>
          <p className="text-[#F4F1EB]/80">+351 935 316 194</p>
          <p className="text-[#F4F1EB]/80 mt-2">Lisboa, Portugal</p>
        </div>
        <div className="text-sm">
          <div className="overline mb-4">Menu</div>
          <ul className="space-y-2">
            <li><a href="/#services" className="hover:text-[#C5A059] transition-colors">{t.nav.services}</a></li>
            <li><a href="/#houses" className="hover:text-[#C5A059] transition-colors">{t.nav.houses}</a></li>
            <li><a href="/#contact" className="hover:text-[#C5A059] transition-colors">{t.nav.contact}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#F4F1EB]/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between gap-2 text-xs text-[#F4F1EB]/50">
          <span>© {year} StayZen. {t.footer.rights}</span>
          <span>Lisboa · Porto · Cascais · Comporta</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
